<template>
  <v-container>
    <v-layout>
      <v-flex sm6 xs6 v-if="$vuetify.breakpoint.mdAndUp">
        <h1 style="padding-left: 8px">{{$t('announcements.edit.title')}}</h1>
      </v-flex>
      <v-flex text-xs-right sm6 xs6 v-if="$vuetify.breakpoint.mdAndUp">
        <v-btn color="primary" class="primary-text" @click="showCreateDialog">
          <v-icon left>add</v-icon>
          <span>{{$t('announcements.admin.create_button')}}</span>
        </v-btn>
      </v-flex>
    </v-layout>
    <transition-group name="list-complete" tag="div" class="layout row wrap" mode="out-in">
      <v-flex v-for="announcement in allAnnouncements" :key="announcement.id" xs12 sm6 md4 lg3 xl2 pa-2>
        <v-card>
          <v-list>
            <v-layout style="padding-top: 0" row wrap class="px-3">
              <v-flex xs12 class="body-2">{{$t('announcements.message')}}</v-flex>
              <div class="truncate">
                {{announcement.message}}
              </div>
            </v-layout>
            <v-layout row wrap class="px-3 pt-2">
              <v-flex xs6 class="body-2">{{$t('date_from')}}</v-flex>
              <v-flex xs6 class="body-2">{{$t('date_to')}}</v-flex>
              <v-flex xs6>
                <div class="truncate">
                  {{announcement.fromDate | date}}
                </div>
              </v-flex>
              <v-flex xs6>
                <div class="truncate">
                  <span v-if="announcement.toDate">{{announcement.toDate | date}}</span>
                  <span v-else>{{$t('indefinite')}}</span>
                </div>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="px-3 pt-2">
              <v-flex xs12 class="body-2">{{$t('announcements.visibility')}}</v-flex>
              <v-flex xs12 class="truncate">
                {{getAnnouncementRoles(announcement.role)}}
              </v-flex>
            </v-layout>
            <v-layout row wrap class="px-3 pt-2">
              <v-flex xs12 class="body-2">{{$t('announcements.severity')}}</v-flex>
              <v-flex xs12 class="truncate">
                {{$t(`announcements.severities.${announcement.severity}`)}}
              </v-flex>
            </v-layout>
          </v-list>
          <v-card-actions>
            <v-btn flat @click="toggleAnnouncement(announcement)">
              <span class="success--text" v-if="announcement.enabled">{{$t('announcements.status.enabled')}}</span>
              <span class="" v-else>{{$t('announcements.status.disabled')}}</span>
            </v-btn>
            <v-spacer/>
            <v-btn icon @click="showEditDialog(announcement)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon @click="deleteAnnouncement({id: announcement.id, delete: true})">
              <v-icon>delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </transition-group>
    <v-dialog v-model="announcementDialogVisibility" max-width="500px">
      <announcement-edit-dialog/>
    </v-dialog>
    <v-btn color="secondary" v-if="$vuetify.breakpoint.smAndDown" fab fixed bottom right secondary
           @click="showCreateDialog">
      <v-icon class="secondary-text">add</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
  import DateFormat from '../../../mixins/DateFormat'
  import { mapActions, mapMutations, mapState } from 'vuex'
  import { DELETE_ANNOUNCEMENT, FETCH_ALL_ANNOUNCEMENTS, TOGGLE_ADMIN_ANNOUNCEMENT } from '../../../store/action-types'
  import AnnouncementEditDialog from './AnnouncementEditDialog'
  import {
    EDIT_ANNOUNCEMENT,
    SET_ANNOUNCEMENT_DIALOG_STATE,
    SET_ANNOUNCEMENT_DIALOG_STATE_VISIBLITY
  } from '../../../store/mutation-types'
  import moment from 'moment-es6'

  export default {
    name: 'announcement-edit-page',
    components: {AnnouncementEditDialog},
    props: [],
    mixins: [DateFormat],
    data () {
      return {
        createButton: {
          icon: 'add',
          color: this.$vuetify.theme.secondary,
          action: this.showCreateDialog
        }
      }
    },
    methods: {
      ...mapActions({
        fetchAllAnnouncements: FETCH_ALL_ANNOUNCEMENTS,
        toggleAnnouncement: TOGGLE_ADMIN_ANNOUNCEMENT,
        deleteAnnouncement: DELETE_ANNOUNCEMENT
      }),
      ...mapMutations({
        setEditAnnouncement: EDIT_ANNOUNCEMENT
      }),
      showEditDialog (announcement) {
        this.setEditAnnouncement(announcement)
        this.announcementDialogState = {visible: true, edit: true}
      },
      showCreateDialog () {
        this.setEditAnnouncement({
          message: '',
          role: '',
          severity: '',
          enabled: true,
          fromDate: moment().format('YYYY-MM-DD'),
          toDate: moment().format('YYYY-MM-DD')
        })
        this.announcementDialogState = {visible: true, edit: false}
      }
    },
    computed: {
      ...mapState({
        allAnnouncements: state => state.announcement.allAnnouncements
      }),
      getAnnouncementRoles () {
        return (roleString) => {
          const roleArray = roleString.split(',')
          let displayString = ''

          roleArray
            .forEach((role, idx) => {
              displayString += this.$t(`announcements.roles.${role}`)
              // Add comma if not last element
              if (!(idx === roleArray.length - 1)) {
                displayString += ', '
              }
            })

          return displayString
        }
      },
      announcementDialogState: {
        get () {
          return this.$store.state.announcement.announcementDialogState
        },
        set (value) {
          this.$store.commit(SET_ANNOUNCEMENT_DIALOG_STATE, value)
        }
      },
      announcementDialogVisibility: {
        get () {
          return this.$store.state.announcement.announcementDialogState.visible
        },
        set (value) {
          this.$store.commit(SET_ANNOUNCEMENT_DIALOG_STATE_VISIBLITY, value)
        }
      }
    },
    watch: {},
    filters: {
      severity (value) {}
    },
    mounted () {
      this.fetchAllAnnouncements()
    }
  }
</script>

<style>
  .list-complete-item {
    transition: all 0.5s;
    display: inline-block;
  }

  .list-complete-enter {
    opacity: 1;
    transition: all 0.5s;
  }

  .list-complete-leave-to {
    opacity: 0;
    position: absolute;
    transition: all 0.5s ease-in;
  }

  .list-complete-enter-active {
    transition: all 0.5s ease;
    transition-delay: 100ms
  }

  .list-complete-leave-active {
    position: absolute;
    transition: all 0.5s;
  }

  .list-complete-move {
    transition: all 0.5s;
  }
</style>




// WEBPACK FOOTER //
// src/components/announcement/edit/AnnouncementEditPage.vue